<template>
  <div class="public-title-components">
    <div class="page_title">
      <custom-breadcrumb :suffix="`# ${serviceOrderId}`"/>
    </div>
    <div class="public-title-steps">
      <el-steps :active="active" align-center>
        <el-step title="Apply for a refund" icon="el-icon-success"></el-step>
        <el-step title="Refund Under Review" icon="el-icon-success"></el-step>
        <el-step title="Completed" icon="el-icon-success"></el-step>
      </el-steps>
    </div>
    <div class="shipped-content-title">
      <div class="shipped-content">
        <div class="shipped-content-title medium">
          <div v-if="active === 2">Refund Under Review</div>
          <div v-if="active === 3">Completed</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 头部组件---移动 pc混用
import CustomBreadcrumb from '../../../components/custom-breadcrumb'

export default {
  name: 'publicTitle',
  props: {
    active: {
      type: Number,
      default: 2
    },
    serviceOrderId: {
      type: String,
      default: ''
    }
  },
  components:{
    CustomBreadcrumb
  },
  methods: {
    gotoOrders() {
      this.$router.push({path: 'Order'})
    },
    gotoServiceOrders() {
      this.$router.push({path: 'service-order'})
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-step__head.is-finish{color: #303133 ;border-color: #303133;font-weight: 700;}
/deep/ .el-step__title.is-finish{color: #303133 ;border-color: #303133;font-weight: 700;}
/deep/ .el-step__title.is-process{color: #8F8F8F ;border-color: #8F8F8F;}
/deep/ .el-step__head.is-process{color: #8F8F8F ;border-color: #8F8F8F;}
.shipped-content{
  width: 100%;
  margin:  0 auto;
  margin-top: 30px;
  box-sizing: border-box;
  border: 1px solid #E1E1E1;
  .shipped-content-title{
    height: 60px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
  }
  .pc-shipped-content-title{
    width: 177px;
    height: 40px;
    background: #262613;
    opacity: 1;
    border-radius: 3px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
  }
}

.m-shipped-content-title{
  display: none;
}
.medium{
  font-family: Satoshi-medium;
}
@media screen and (max-width: 1024px){
  //小于1400px的媒体查询
  .public-title,.public-title-steps{
    display: none;
  }
  .public-title-components{
    padding-top:80px !important;
  }
  .public-title-order{
    height: 53px;
    padding: 0 !important;
    font-size: 20px !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.public-title-components{
  // padding-top: 200px;
 .public-title{
    width: 100%;
    margin: 0 auto;
    padding-bottom: 22px;
    border-bottom: 1px solid #E1E1E1;
  }
  .public-title-order{
    text-align: center;
    padding: 20px 0 40px;
    font-size: 25px;
    font-family: Satoshi-bold;
    color: #262B2F;
  }
  .public-title-steps{
    max-width: 1600px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/public-title.vue